var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teaching-bpx"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu4-2'),"subtitle":"Transport teaching"}}),_c('div',{staticClass:"layout-step-box layout-width",attrs:{"id":"articlel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }